import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

/* ─────────────────────────────────────────────
   YOUR SCHOLARSHIP FINDER — OUR STORY PAGE
   Uses the same founder story layout as current production
   Feature branch: feature/homepage-redesign
   S63: Mobile responsive fixes (Annette feedback)
   ───────────────────────────────────────────── */

const T = {
  navy:      '#10314F',
  navyLight: '#33475C',
  navyMuted: '#5A6B7D',
  navyFaint: '#B9C6D4',
  navyBorder:'#2A4B6B',
  gold:      '#EF9F27',
  goldDark:  '#9A5B06',
  goldLight: '#FCEBD0',
  bg:        '#F7F5F0',
  border:    '#E6E1D6',
  white:     '#FFFFFF',
  lightText: '#E3EAF2',
  serif:     "Fraunces, Georgia, serif",
  sans:      "Inter, 'Helvetica Neue', Helvetica, Arial, sans-serif",
};

const responsiveCSS = `
  .os-nav-links { display: flex; align-items: center; gap: 36px; }
  .os-nav-mobile-btn { display: none; }
  .os-story-grid { display: grid; grid-template-columns: 1fr 1.4fr; gap: 48px; align-items: start; }
  .os-giveback-grid { display: grid; grid-template-columns: 7fr 5fr; gap: 72px; align-items: center; }

  @media (max-width: 768px) {
    .os-nav-links { display: none; }
    .os-nav-mobile-btn { display: block; }
    .os-section-pad { padding-left: 20px !important; padding-right: 20px !important; }
    .os-nav-pad { padding-left: 20px !important; padding-right: 20px !important; }
    .os-story-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
    .os-story-photos { flex-direction: row !important; }
    .os-story-photos > div { flex: 1; }
    .os-giveback-grid { grid-template-columns: 1fr !important; gap: 24px !important; }
    .os-giveback-grid h2 { font-size: 28px !important; }
    .os-final-cta h2 { font-size: 36px !important; }
    .os-story-heading { font-size: 26px !important; }
    .os-story-blockquote { font-size: 18px !important; }
  }
`;

const LogoSVG = () => (
  <svg width="44" height="44" viewBox="0 0 100 100" aria-hidden="true">
    <rect x="0" y="0" width="100" height="100" rx="24" fill={T.navy} />
    <path d="M50 18 C36 18 26 29 26 42 C26 58 50 84 50 84 C50 84 74 58 74 42 C74 29 64 18 50 18 Z" fill={T.white} />
    <circle cx="50" cy="41" r="8.5" fill={T.gold} />
  </svg>
);

export default function OurStory({ social }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const base = social ? '/social' : '';

  useEffect(() => {
    const id = 'os-responsive-styles';
    if (!document.getElementById(id)) {
      const style = document.createElement('style');
      style.id = id;
      style.textContent = responsiveCSS;
      document.head.appendChild(style);
    }
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

    const handleCheckout = () => {
    window.location.href = `${base}/#pricing`;
  };

  return (
    <div style={{ fontFamily: T.sans, color: T.navy, background: T.bg, minHeight: '100vh' }}>

      {/* ══════ NAV ══════ */}
      <header className="os-nav-pad" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '22px 96px', background: T.white, borderBottom: `1px solid ${T.border}`, position: 'sticky', top: 0, zIndex: 100 }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 14, textDecoration: 'none' }}>
          <LogoSVG />
          <span style={{ fontFamily: T.serif, fontSize: 25, lineHeight: 1, color: T.navy }}>
            <span style={{ fontStyle: 'italic', fontWeight: 400, color: T.navyMuted }}>Your</span>{' '}
            <span style={{ fontWeight: 500 }}>Scholarship Finder</span>
          </span>
        </Link>
        <nav className="os-nav-links" style={{ fontSize: 16, fontWeight: 500 }}>
                    <Link to={`${base}/#who`} style={{ textDecoration: 'none', color: T.navy }}>Who it's for</Link>
          <Link to={`${base}/#how`} style={{ textDecoration: 'none', color: T.navy }}>How it works</Link>
          <Link to={`${base}/our-story`} style={{ textDecoration: 'none', color: T.navy, fontWeight: 700, borderBottom: `2px solid ${T.gold}`, paddingBottom: 4 }}>Our story</Link>
          <Link to={`${base}/#pricing`} style={{ textDecoration: 'none', color: T.navy }}>Pricing</Link>
          <Link to="/login" style={{ textDecoration: 'none', color: T.navy }}>Log in</Link>
          <button onClick={handleCheckout} style={{ background: T.navy, color: T.white, padding: '13px 22px', borderRadius: 10, fontWeight: 600, fontSize: 16, border: 'none', cursor: 'pointer', fontFamily: T.sans }}>
            Get started
          </button>
        </nav>
        <button className="os-nav-mobile-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8 }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={T.navy} strokeWidth="2"><path d="M3 6h18M3 12h18M3 18h18" /></svg>
        </button>
      </header>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div style={{ background: T.white, borderBottom: `1px solid ${T.border}`, padding: '16px 24px', display: 'flex', flexDirection: 'column', gap: 16, position: 'sticky', top: 72, zIndex: 99 }}>
          <Link to={`${base}/`} onClick={() => setMobileMenuOpen(false)} style={{ textDecoration: 'none', color: T.navy, fontWeight: 500, fontSize: 15 }}>Home</Link>
          <Link to={`${base}/our-story`} onClick={() => setMobileMenuOpen(false)} style={{ textDecoration: 'none', color: T.navy, fontWeight: 700, fontSize: 15 }}>Our story</Link>
          <Link to="/login" onClick={() => setMobileMenuOpen(false)} style={{ textDecoration: 'none', color: T.navy, fontWeight: 500, fontSize: 15 }}>Log in</Link>
          <button onClick={handleCheckout} style={{ background: T.navy, color: T.white, padding: '11px 20px', borderRadius: 10, fontWeight: 600, border: 'none', cursor: 'pointer', fontFamily: T.sans, fontSize: 15 }}>Get started</button>
        </div>
      )}


      {/* ══════ STORY — PRODUCTION LAYOUT ══════ */}
      <section className="os-section-pad" style={{ background: T.white, borderBottom: `1px solid ${T.border}`, padding: '96px 0' }}>
        <div className="os-story-grid" style={{ maxWidth: 1120, margin: '0 auto', padding: '0 32px' }}>

          {/* Left — Photos */}
          <div className="os-story-photos" style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
              <img src="/matt.jpg" alt="Matt Phillips" style={{ width: '100%', aspectRatio: '1/1', objectFit: 'cover', borderRadius: 14, border: `1px solid ${T.border}` }} />
              <div style={{ fontFamily: T.serif, fontSize: 15, fontWeight: 500, color: T.navy }}>Matt Phillips</div>
              <div style={{ fontSize: 12, color: T.navyMuted, letterSpacing: '0.04em' }}>Co-Founder & CEO</div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
              <img src="/ramesh.jpg" alt="Ramesh Cooke" style={{ width: '100%', aspectRatio: '1/1', objectFit: 'cover', borderRadius: 14, border: `1px solid ${T.border}` }} />
              <div style={{ fontFamily: T.serif, fontSize: 15, fontWeight: 500, color: T.navy }}>Ramesh Cooke</div>
              <div style={{ fontSize: 12, color: T.navyMuted, letterSpacing: '0.04em' }}>Co-Founder & CTO</div>
            </div>
          </div>

          {/* Right — Story */}
          <div>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 12.5, fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: T.goldDark, marginBottom: 12 }}>
              <span style={{ width: 16, height: 1, background: T.goldDark }} />
              Why we built it
            </div>
            <h2 className="os-story-heading" style={{ fontFamily: T.serif, fontWeight: 500, fontSize: 32, marginBottom: 18, lineHeight: 1.15 }}>One of us lived it. The other knew how to fix it.</h2>

            <p style={{ color: T.navyLight, marginBottom: 16, fontSize: 15.5, lineHeight: 1.75 }}>
              My wife and I have three kids. Two are in college now; the third is four years out. We knew what that was going to cost, and we knew scholarships were sitting out there — so we did what a lot of parents do. We sat our kids down, explained what a decade of loan payments actually looks like, and told them we expected them to apply.
            </p>
            <p style={{ color: T.navyLight, marginBottom: 16, fontSize: 15.5, lineHeight: 1.75 }}>
              They said okay. They went to the scholarship sites everyone uses. They applied to a couple. And then it stopped.
            </p>
            <p style={{ color: T.navyLight, marginBottom: 16, fontSize: 15.5, lineHeight: 1.75 }}>
              So we both pushed. <em>Put in the time. Do you understand what this pays for.</em> They kept telling us the sites were painful, that there was nothing there — and we didn't believe them. We thought they were being lazy. This was the cause of the kitchen-table fights, and there were a lot of them.
            </p>
            <p style={{ color: T.navyLight, marginBottom: 16, fontSize: 15.5, lineHeight: 1.75 }}>
              Eventually, my wife and I logged into their accounts to prove a point.
            </p>
            <p style={{ color: T.navyLight, marginBottom: 16, fontSize: 15.5, lineHeight: 1.75 }}>
              I searched hockey scholarships first. My son plays, and we live in Denver. What came back was a scholarship restricted to a small town in northern Minnesota. Then I went looking for my daughter, using her actual interests, and hit the same wall — page after page of things she could never win.
            </p>

            <blockquote className="os-story-blockquote" style={{ margin: '28px 0', padding: '0 0 0 20px', borderLeft: `3px solid ${T.gold}`, fontFamily: T.serif, fontWeight: 500, fontSize: 22, lineHeight: 1.35, color: T.navy }}>
              They weren't quitting. The tool was broken. No wonder these kids give up.
            </blockquote>

            <p style={{ color: T.navyLight, marginBottom: 16, fontSize: 15.5, lineHeight: 1.75 }}>
              So we went back to our kids and apologized. They hadn't been lazy. They'd done exactly what we would have done in their shoes — spent hours getting nowhere, and stopped wasting their time.
            </p>
            <p style={{ color: T.navyLight, marginBottom: 16, fontSize: 15.5, lineHeight: 1.75 }}>
              I knew what was broken. I didn't know how to fix it. That's when I brought it to Ramesh.
            </p>
            <p style={{ color: T.navyLight, marginBottom: 16, fontSize: 15.5, lineHeight: 1.75 }}>
              Ramesh has spent more than 20 years building enterprise software — large-scale ERP implementations, and then his own technology consultancy. He saw what I couldn't: AI could actually solve it.
            </p>
            <p style={{ color: T.navyLight, marginBottom: 16, fontSize: 15.5, lineHeight: 1.75 }}>
              Within weeks he had a working prototype that pulled a $1.76 million Colorado scholarship straight out of IRS filings — money most consumer scholarship sites never list. That's when we knew this was real.
            </p>
            <p style={{ color: T.navyLight, marginBottom: 16, fontSize: 15.5, lineHeight: 1.75 }}>
              We built the tool that should have existed when our kids needed it — so students can spend their energy applying instead of searching, and parents don't have to have the fight we did.
            </p>

            <div style={{ marginTop: 22, fontFamily: T.serif, fontStyle: 'italic', fontSize: 16, color: T.navy }}>
              — Matt Phillips
              <span style={{ display: 'block', fontFamily: T.sans, fontStyle: 'normal', fontSize: 12.5, color: T.navyMuted, marginTop: 2 }}>Co-Founder & CEO, Your Scholarship Finder</span>
            </div>
          </div>
        </div>
      </section>


      {/* ══════ GIVE-BACK ══════ */}
      <section className="os-section-pad" style={{ padding: '72px 96px', background: T.goldLight }}>
        <div className="os-giveback-grid" style={{ maxWidth: 1120, margin: '0 auto' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ fontSize: 14, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: T.goldDark }}>Beyond the scholarships</div>
            <h2 style={{ margin: 0, fontFamily: T.serif, fontWeight: 500, fontSize: 40, lineHeight: 1.15 }}>
              10% of membership revenue goes to your student's designated high school.
            </h2>
          </div>
          <p style={{ margin: 0, fontSize: 19, lineHeight: 1.65, color: T.navyLight }}>
            Sports teams, the band, whatever the school needs most. Schools receive an aggregate total and never see which families joined.
          </p>
        </div>
      </section>


      {/* ══════ FINAL CTA + FOOTER ══════ */}
      <section className="os-section-pad os-final-cta" style={{ background: T.navy, color: T.white, padding: '96px 96px 48px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 28, textAlign: 'center' }}>
        <h2 style={{ margin: 0, fontFamily: T.serif, fontWeight: 500, fontSize: 64, lineHeight: 1.05, letterSpacing: '-0.02em', color: T.gold }}>
          Stop scrolling. Start applying.
        </h2>
        <p style={{ margin: 0, fontSize: 20, lineHeight: 1.55, color: T.lightText, maxWidth: 640 }}>
          Give your student the list we wish ours had. Profile in about 3 minutes, matches in 60 seconds.
        </p>
        <button onClick={handleCheckout} style={{ background: T.gold, color: T.navy, padding: '19px 32px', borderRadius: 12, fontSize: 18, fontWeight: 700, border: 'none', cursor: 'pointer', fontFamily: T.sans }}>
          Get your student's matches →
        </button>
        <div style={{ flexGrow: 1, minHeight: 40 }} />
        <div style={{ width: '100%', borderTop: `1px solid ${T.navyBorder}`, paddingTop: 28, display: 'flex', justifyContent: 'space-between', fontSize: 14, color: T.navyFaint, flexWrap: 'wrap', gap: 16 }}>
          <span>© 2026 Your Scholarship Finder. A service of ScholarSync AI LLC.</span>
          <span>
            <Link to="/terms" style={{ color: T.navyFaint, textDecoration: 'none' }}>Terms of Service</Link>
            {' · '}
            <Link to="/privacy" style={{ color: T.navyFaint, textDecoration: 'none' }}>Privacy Policy</Link>
            {' · '}
            <a href="mailto:theteam@yourscholarshipfinder.com" style={{ color: T.navyFaint, textDecoration: 'none' }}>Contact</a>
          </span>
        </div>
      </section>

    </div>
  );
}
